import { PropsWithChildren } from 'react';
import { AnyState, Sender } from 'xstate';
import { DevToolsButton } from '~/app/dev-tools';
import { Header } from '~/components/header';
import { PromoBanner } from '~/components/promo-banner';
import { ParsedQueryParams } from '~/providers/query-params';
import { FetchFunnelPacketResponse } from '~/services/fetch-funnel-packet';
import { IS_PRODUCTION } from '~/utils/constants';

export type FunnelPageProps = PropsWithChildren<{
  defaultDevTools?: boolean;
  defaultPromoBanner?: boolean;
  defaultHeader?: boolean;
  funnel: {
    context: any;
    send: Sender<any>;
    state: AnyState;
  };
  micro?: {
    send: Sender<any>;
  };
  step: {
    active: string;
    funnelId: string;
    testId: string;
  };
}>;

export const FunnelPage = ({
  children,
  defaultDevTools = true,
  defaultPromoBanner = true,
  defaultHeader = true,
  funnel,
  micro,
  step,
}: FunnelPageProps) => {
  return (
    <div data-testid={step.testId}>
      {defaultDevTools && !IS_PRODUCTION && (
        <DevToolsButton
          currentState={funnel.state}
          funnelId={step.funnelId}
          next={micro?.send || funnel?.send}
        />
      )}
      {defaultPromoBanner && (
        <PromoBanner
          promoCode={(funnel.context?.queryParams as ParsedQueryParams)?.promoCode}
          step={step.active}
          utilityId={(funnel.context?.funnelPacket as FetchFunnelPacketResponse)?.utility?.id}
        />
      )}
      {defaultHeader && <Header badge="Community solar" />}
      {children}
    </div>
  );
};
